<template>
    <section id="loginWrapper" class="flexContainer fd-r m-fd-c t-fd-c flex-1">
        <div class="imgLogin size3of4" v-if="suffix && (suffix === 'pp-api.rem3rch.com' || suffix === 'api.rem3rch.com')"><anim></anim></div>
        <div
            class="imgLogin size3of4"
            v-if="suffix && suffix !== 'pp-api.rem3rch.com' && suffix !== 'api.rem3rch.com'"
            style="font-size: 50px; background-color: deeppink"
        >
            {{ suffix }}
        </div>
        <div class="login size1of4 flexContainer fd-c jc-c rel">
            <loader :loading="loading"></loader>
            <div class="flexContainer fd-c loginForm full rel">
                <img id="logoRem3rch" src="../../assets/Logo-login.png" width="150px" alt="" />
                <div v-if="currentStatus === status.FIRST_STEP">
                    <div class="input-group rel">
                        <input type="email" placeholder="Email" id="email" v-model.trim="user.login" name="email" @keyup.enter="goToSecondStep()" />
                        <img class="abs" src="../../../static/img/user.png" width="21" height="18" alt="" />
                    </div>
                    <button class="btn log loginButton" @click="goToSecondStep()">Next</button>
                </div>
                <div v-if="currentStatus === status.SECOND_STEP">
                    <p class="user-email" @click="currentStatus = status.FIRST_STEP"><span class="left-arrow">&larr;</span>{{ user.login }}</p>
                    <div class="input-group rel">
                        <input type="password" ref="passwordField" placeholder="Password" v-model.trim="user.pwd" @keyup.enter="check()" />
                        <img class="abs" src="../../../static/img/pwd.png" width="12" height="18" alt="" />
                    </div>
                    <button class="btn log loginButton" type="submit" @click="check()">Log in</button>
                    <button class="btn log loginButton" style="white-space: normal" @click="triggerResetPassword()">Forgot password?</button>

                    <div v-if="cgu">
                        <label class="condition">
                            <input type="checkbox" v-model="cookiesChecked" id="agree" /> I have read and agree to the Rem3rch
                            <a target="_blank" class="supportLink" href="../../../static/Rem3rch_mentions_légales_conditions_utilisation.pdf">
                                terms and conditions
                            </a>
                        </label>
                    </div>
                </div>
                <div v-if="currentStatus === status.RESET_PASSWORD">
                    <p style="color: white;">
                        Passwords should be at least 8 characters long and contain at least one lower case letter, one number and one upper case
                        letter.
                    </p>
                    <div class="input-group rel">
                        <input
                            v-if="passwordReset.newPassword.isVisible"
                            type="text"
                            placeholder="Enter new password"
                            v-model="passwordReset.newPassword.value"
                        />
                        <input v-else type="password" placeholder="Enter new password" v-model="passwordReset.newPassword.value" />
                        <img
                            class="abs password-icon"
                            v-bind:src="passwordIcon(passwordReset.newPassword.isVisible)"
                            width="12"
                            height="18"
                            alt=""
                            @click="passwordReset.newPassword.isVisible = !passwordReset.newPassword.isVisible"
                        />
                    </div>
                    <div class="input-group rel">
                        <input
                            v-if="passwordReset.newPasswordRepeat.isVisible"
                            type="text"
                            placeholder="Enter new password"
                            v-model="passwordReset.newPasswordRepeat.value"
                        />
                        <input v-else type="password" placeholder="Enter new password" v-model="passwordReset.newPasswordRepeat.value" />
                        <img
                            class="abs password-icon"
                            v-bind:src="passwordIcon(passwordReset.newPasswordRepeat.isVisible)"
                            width="12"
                            height="18"
                            alt=""
                            @click="passwordReset.newPasswordRepeat.isVisible = !passwordReset.newPasswordRepeat.isVisible"
                        />
                    </div>
                    <button class="btn log loginButton" type="submit" @click="sendNewPassword()">Submit</button>
                </div>
            </div>
        </div>
        <Cookie></Cookie>
    </section>
</template>

<script>
import Vue from "vue";
import Globals from "../globals.js";
import VueSession from "vue-session";
import animLogin from "../login/animLogin.vue";
import loader from "../loader/loader";
import cacheService from "@/services/cache";
import Cookie from "@/components/login/Cookie";
import currentBrandService from "@/services/currentBrand";

Vue.use(VueSession);
export default {
    data: () => ({
        user: {
            login: null,
            pwd: null
        },
        cookiesChecked: false,
        loading: false,
        cookies: null,
        cgu: false,
        passwordReset: {
            token: null,
            newPassword: {
                isVisible: false,
                value: null
            },
            newPasswordRepeat: {
                isVisible: false,
                value: null
            }
        },
        resetLoginAttempts: {
            token: null
        },
        currentStatus: null,
        status: {
            FIRST_STEP: "first_step",
            SECOND_STEP: "second_step",
            RESET_PASSWORD: "reset_password",
            REACTIVATE_LOGIN: "reactivate_login"
        },
        suffix: null
    }),
    components: {
        Cookie,
        anim: animLogin,
        loader: loader
    },
    beforeMount() {
        this.currentStatus = this.status.FIRST_STEP;
        if (undefined !== this.$route.query.passwordResetToken) {
            this.passwordReset.token = this.$route.query.passwordResetToken;
            this.currentStatus = this.status.RESET_PASSWORD;
        }

        if (undefined !== this.$route.query.resetLoginAttempts) {
            this.resetLoginAttempts.token = this.$route.query.resetLoginAttempts;
            this.currentStatus = this.status.REACTIVATE_LOGIN;
            const token = this.resetLoginAttempts.token;
            Vue.http.post(Globals.getBaseUrl() + "/resetLoginAttemptsByToken?token=" + token).then(resp => {
                this.redirectToLogin();
            });
        }
        if (undefined !== this.$route.query.token) {
            const token = this.$route.query.token;
            Vue.http.post(Globals.getBaseUrl() + "/login-token", JSON.stringify({ token: token })).then(resp => {
                let { user, token } = resp.data;
                this.logUserIn(user, token);
            });
        }
    },
    methods: {
        passwordIcon(visibility) {
            const path = "../../../static/assets/";
            let image = visibility ? "icon-eye-closed.png" : "icon-eye-open.png";
            return path + image;
        },
        async goToSecondStep() {
            if (!this.user.login) {
                return;
            }
            const resp = await Vue.http.post(Globals.getBaseUrl() + "/login-email", JSON.stringify({ email: this.user.login }));
            await this.redirectToSsoIfRequired(resp);
            this.currentStatus = this.status.SECOND_STEP;
            this.$nextTick(() => {
                this.$refs.passwordField.focus();
            });
        },
        async redirectToSsoIfRequired(response) {
            return new Promise(resolve => {
                if (response.data["code"] === 302) {
                    window.location.replace(response.data["location"]);
                } else {
                    resolve();
                }
            });
        },
        triggerResetPassword() {
            Vue.http
                .post(Globals.getBaseUrl() + "/request-password-reset", JSON.stringify({ email: this.user.login }))
                .then(response => {
                    this.$swal({
                        title: "We have sent you an email",
                        html:
                            "<p>A password reset link has been sent to your verified email address.</p>" +
                            "<p>This link is valid for 24 hours. </p>" +
                            "<p>Please make sure <b>noreply@rem3rch.com</b> is added to your safe senders list to stop this and future emails from us being stopped by spam filters.</p>"
                    });
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        text: "Something went wrong"
                    });
                });
        },
        sendNewPassword() {
            let newPw = this.passwordReset.newPassword.value;
            let newPwRepeat = this.passwordReset.newPasswordRepeat.value;
            if (newPw !== newPwRepeat) {
                this.$swal({
                    title: "Passwords are not equal"
                });
                return;
            }

            Vue.http
                .post(Globals.getBaseUrl() + "/reset-password", JSON.stringify({ new_password: newPw, token: this.passwordReset.token }))
                .then(() => {
                    this.$swal({
                        title: "Your password was reset",
                        onClose: this.redirectToLogin
                    });
                })
                .catch(err => {
                    if (undefined !== err.body.error_code && err.body.error_code === "password_constraint_violation") {
                        this.$swal({
                            type: "error",
                            text: "Your password is not valid"
                        });
                        return;
                    }
                    this.$swal({
                        type: "error",
                        text: "Your password was NOT reset. Please try resetting it",
                        onClose: this.redirectToLogin
                    });
                });
        },

        redirectToLogin() {
            window.location.replace("/login");
        },
        async check() {
            Vue.http.options.emulateJSON = true;
            this.loading = true;
            const response = await Vue.http.post(Globals.getBaseUrl() + "/check_login", JSON.stringify(this.user));
            await this.redirectToSsoIfRequired(response);
            if (response.data["code"] === 200) {
                let { user, token } = response.data;
                this.logUserIn(user, token);
            } else {
                this.loading = false;
                let error = "The username / password combination is incorrect. Please try again.";
                this.$swal({
                    type: "error",
                    title: "Oops !",
                    text: error
                });
            }
            return response.data;
        },

        logUserIn(user, token) {
            cacheService.setRem3rchUserAndToken({ user, token });
            // _paq.push(["setCustomVariable", "1", "Visitor Type", rem3rchUser.user.firstname + " " + rem3rchUser.user.lastname]);
            // _paq.push(["setUserId", rem3rchUser.user.id]);
            // this.trackEventMatomo("trackEvent", "Login", "Connexion réussie", rem3rchUser.user.firstname + " " + rem3rchUser.user.lastname);
            _paq.push(["trackEvent", "Login", "Connexion réussie", user.firstname + " " + user.lastname]);
            const currentLangId = (user.preference.activated && user.preference.language.id) || 2;
            const currentLang = user.languages.find(lang => lang.id == currentLangId);
            cacheService.set("userLangId", currentLang.id);
            const preference = user.preference;
            const brands = cacheService.getBrands();
            if (brands.length === 0) {
                this.loading = false;
                let error = "This account has no rights to the application";
                this.$swal({
                    type: "error",
                    title: "Oops !",
                    text: error
                });
            }
            let brandId = preference.activated ? preference.brand.id : brands[0].id;
            this.setLocalStorageDatas(brands, brandId, preference);
            this.loading = false;
            let urlRedirect = sessionStorage.getItem("urlKept") || "/";
            sessionStorage.removeItem("urlKept");
            window.location.replace(urlRedirect);
        },
        setLocalStorageDatas(brandsList, brandId, preference) {
            let currentBrand = brandsList.find(brand => parseInt(brand.id) === parseInt(brandId));
            let prefBrand = currentBrand;
            prefBrand.urlImg = Globals.getBaseUrl() + currentBrand.imgPath + currentBrand.logo;
            const currentZone =
                (preference.activated && currentBrand.zones.find(zone => parseInt(zone.id) === parseInt(preference.zone.id))) ||
                currentBrand.zones[0];
            let { id, name, abbreviation } = currentZone;
            let prefZone = { id, name, abbreviation };

            const currentStand =
                (preference.activated && currentBrand.stands.find(stand => parseInt(stand.id) === parseInt(preference.stand.id))) ||
                currentBrand.stands[0];
            ({ id, name } = currentStand);
            let prefStand = { id, name };

            const currentCampaign =
                (preference.activated && currentBrand.campaigns.find(campaign => parseInt(campaign.id) === parseInt(preference.campaign.id))) || 0;
            ({ id, name } = currentCampaign);
            let { shortName } = currentCampaign;
            let prefCampaigns = { id, name, shortName };
            /**
             * Add DATA localStorage
             */
            cacheService.set("currentBrandId", prefBrand.id);
            cacheService.set("currentZoneId", prefZone.id);
            cacheService.set("currentStandId", prefStand.id);
            cacheService.set("currentCampaignId", prefCampaigns.id ? prefCampaigns.id : "0");
        }
    },
    created() {
        this.cookies = document.cookie;
        this.suffix = Globals.suffixUrl;
    }
};
</script>

<style scoped lang="scss">
.loginButton {
    background-color: transparent;
    opacity: 0.7;
    -webkit-transition: all 0.2s linear;
    -moz-transition: all 0.2s linear;
    -ms-transition: all 0.2s linear;
    -o-transition: all 0.2s linear;
    transition: all 0.2s linear;
    color: #ffffff;

    &:hover {
        color: #ffffff;
        opacity: 1;
    }
}

.condition,
a {
    color: white;
    font-size: 11px;
}

#loginWrapper {
    height: 100vh;
    background: #343434;

    .login {
        background-color: #343434;
        height: inherit;
    }
}

.imgLogin {
    background: #343434;
}

.loginForm {
    margin: auto;
    padding: 0 80px;

    input {
        background-color: transparent;
        border: none;
        color: #ffffff;
        margin-top: 30px;
        font-family: Roboto;
        font-size: 14px;

        &:focus {
            outline: none;
        }
    }

    .input-group {
        border-bottom: 1px solid #f4f4f4;

        input {
            width: 90%;
        }

        img {
            right: 5px;
            z-index: 5;
            bottom: 0px;
            margin-bottom: 1.5%;
        }
    }
}

#logoRem3rch {
    margin-left: auto;
    margin-right: auto;
}

.log {
    color: #ffffff; //it is no more important because the color taken is th color of input
    margin-top: 30px;
    width: 100px;
    display: block;
    margin-left: auto;
    margin-right: auto;
    border: 1px solid #fff !important;
    cursor: pointer;
}

.forgot {
    display: block;
    width: 100%;
    text-align: center;
    margin-top: 15px;

    a {
        margin-top: 30px;
        color: #f4f4f4;
        font-size: 11px;
        text-decoration: none;
        border-bottom: 1px solid;
    }
}

.password-icon {
    background-color: #c1c1c1;
    width: 25px;
    height: 25px;
    padding: 3px;
}

.user-email {
    color: white;
    cursor: pointer;
    white-space: nowrap;
}

.left-arrow {
    padding-right: 10px;
}

@media only screen and (max-width: 767px) {
    .imgLogin,
    .login {
        width: 100%;
    }
    .imgLogin {
        height: 357px;
    }
    .loginForm {
        padding: 0px 30px;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    #loginWrapper {
        display: block;

        .login {
            width: 100%;
            height: auto;
        }
    }
    .imgLogin {
        height: 50%;
        width: 100%;
    }
    .loginForm {
        margin-top: 0;
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// Login.vue?18a0aff7